<template>
  <section>
    <div class="pop-room material-detail-pop" v-if="detailStatus">
      <a href="javascript:;" @click="closeDetailStatus()" class="iconfont icon-close"></a>
      <div class="pop-cont">
        <h3 class="title">低值易耗品入库单</h3>
        <el-col :span="23" v-if="consumableInData">
          <el-form ref="form" label-width="100px" class="form info-txt-center" style="padding-top:0;">
            <el-form-item label="供应商:">
              {{consumableInData.supplier?consumableInData.supplier.name:''}}
            </el-form-item>
            <el-form-item label="发票号码:">
              {{consumableInData.inVoice}}
            </el-form-item>
            <el-form-item label="入库人:">
              <user-info :userData='consumableInData.creator'></user-info>
            </el-form-item>
            <el-form-item label="供货时间:">
              {{consumableInData.ghTime}}
            </el-form-item>
            <el-form-item label="总金额(元):">
              {{consumableInData.total}}
            </el-form-item>
            <el-form-item class="full" label="物品明细:">
              <div class="material-table">
                <el-table :data="consumableInData.items" border>
                  <el-table-column prop="number" label="材料编号">
                  </el-table-column>
                  <el-table-column prop="name" label="明细名称" width="240">
                  </el-table-column>
                  <el-table-column prop="dlName" label="材料类别" width="200">
                  </el-table-column>
                  <el-table-column prop="unitName" align="center" label="计量单位">
                  </el-table-column>
                  <el-table-column prop="amount" align="center" label="数量">
                  </el-table-column>
                  <el-table-column prop="price" align="center" label="单价(元)">
                  </el-table-column>
                  <el-table-column prop="totalPrice" align="center" label="总价(元)">
                  </el-table-column>
                </el-table>
              </div>
            </el-form-item>
          </el-form>
        </el-col>
      </div>
    </div>
  </section>
</template>
<script>
  import UserInfo from '@/components/UserInfo'
  export default {
    components: {
      UserInfo,
    },
    props: ['detailStatus', 'consumableInData'],
    methods: {
      closeDetailStatus(){
        this.$emit("hideDetail")
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/page/consumable/components/InDetail.vue